import { BaseModel } from "../../core/classes/BaseModel";
import { ApiAsync } from "../../core/classes/ApiAsync";

export class Target extends BaseModel {
  constructor(params) {
    super(params);
  }

  $fields() {
    return [
      "id",
      "activity_id",
      "start",
      "end",
      "target",
      "value",
      "group",
      "user_id",
      "status",
      "target_members",
    ];
  }
}
